import {
  getExplorerUpdateDigitalDossierGeneralInformationDto,
  getExplorerUpsertDigitalDossierBankingInformationDto,
  getExplorerUpdateDigitalDossierTaxInformationDto,
  getExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
  getCommonUpsertProductiveFacilityDto,
  getCommonUpsertProductiveAffidavitDto,
  getCommonUpsertStorageFacilityDto,
  getCommonUpsertStorageAffidavitDto,
} from '@bcba/validators';

const _GetUpdateDigitalDossierGeneralInformationDto =
  getExplorerUpdateDigitalDossierGeneralInformationDto();
export class UpdateDigitalDossierGeneralInformationDto extends _GetUpdateDigitalDossierGeneralInformationDto {}

export const {
  UpsertDigitalDossierBankingInformationDto:
    _UpsertDigitalDossierBankingInformationDto,
} = getExplorerUpsertDigitalDossierBankingInformationDto();
export class UpsertDigitalDossierBankingInformationDto extends _UpsertDigitalDossierBankingInformationDto {}

export const _UpdateDigitalDossierTaxInformationDto =
  getExplorerUpdateDigitalDossierTaxInformationDto();

// This allows using it as a TS type and as a constructor class
export class UpdateDigitalDossierTaxInformationDto extends _UpdateDigitalDossierTaxInformationDto {}

export const {
  ExplorerUpsertDigitalDossierFormsAndDocsInformationDto:
    _ExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
} = getExplorerUpsertDigitalDossierFormsAndDocsInformationDto();

export class ExplorerUpsertDigitalDossierFormsAndDocsInformationDto extends _ExplorerUpsertDigitalDossierFormsAndDocsInformationDto {}

const _GetCommonUpsertProductiveFacilityDto =
  getCommonUpsertProductiveFacilityDto();
export class CommonUpsertProductiveFacilityDto extends _GetCommonUpsertProductiveFacilityDto {}

const _GetCommonUpsertProductiveAffidavitDto =
  getCommonUpsertProductiveAffidavitDto();
export class CommonUpsertProductiveAffidavitDto extends _GetCommonUpsertProductiveAffidavitDto {}

const _GetCommonUpsertStorageFacilityDto = getCommonUpsertStorageFacilityDto();
export class CommonUpsertStorageFacilityDto extends _GetCommonUpsertStorageFacilityDto {}

const _GetCommonUpsertStorageAffidavitDto =
  getCommonUpsertStorageAffidavitDto();
export class CommonUpsertStorageAffidavitDto extends _GetCommonUpsertStorageAffidavitDto {}
